<header>
	<p>
		The following is the setting for the current browser you're using,<br/>
		Some features are only available on certain devices or for logged in users.<br/>
		<button class="revert" (click)="settings.revert()">Revert Settings To default</button>
	</p>
</header>

<div class="settings">

	<section>
		<header>Layout:</header>
		<button (click)="settings.toggle('use_layout_theater')" [class.active]="settings.use_layout_theater">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Theater Mode</span>
		</button>
		<button (click)="settings.toggle('show_leaderboard')" [class.active]="settings.show_leaderboard">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Show Leaderboard</span>
		</button>

		<header>Theme:</header>
		<button (click)="settings.set('theme_name', 'default')" [class.active]="settings.theme_name=='default'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Default</span>
		</button>
		<button (click)="settings.set('theme_name', 'queueblue')" [class.active]="settings.theme_name=='queueblue'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Q's Blues</span>
			<small class="note">V2</small>
		</button>
		<button (click)="settings.set('theme_name', 'fabulous')" [class.active]="settings.theme_name=='fabulous'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Fabulous</span>
		</button>
		<button (click)="settings.set('theme_name', 'blackrose')" [class.active]="settings.theme_name=='blackrose'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Black Rose</span>
		</button>
		<button (click)="settings.set('theme_name', 'evergreen')" [class.active]="settings.theme_name=='evergreen'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Evergreen</span>
		</button>
		<button (click)="settings.set('theme_name', 'cherry')" [class.active]="settings.theme_name=='cherry'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Cherry</span>
		</button>
		<button (click)="settings.set('theme_name', 'cyanic')" [class.active]="settings.theme_name=='cyanic'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Cyanic</span>
			<small class="note">Old Q's Blues</small>
		</button>
		<button (click)="settings.set('theme_name', 'flashbang')" [class.active]="settings.theme_name=='flashbang'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Flashbang</span>
		</button>
		<button (click)="settings.set('theme_name', 'clownlike')" [class.active]="settings.theme_name=='clownlike'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Clownlike</span>
		</button>

		<header>Preferr Old Team Logos</header>
		<button (click)="settings.toggle('prefer_old_team_logos')" [class.active]="settings.prefer_old_team_logos">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Using {{ settings.prefer_old_team_logos ? 'Old': 'New' }} Logos</span>
		</button>
		<p class="option-info">
			If the visual trend of minimalistic curvy letters is too much for you;<br/>
			And you can't tell the teams apart,<br/>
			or you just enjoy the nostalgia, use the old team logos!<br/>
			<small>Also enjoy all the small ways they break our interface!</small>
		</p>

		<header>Give stars to your favourite teams: <small>Effects Sorting by Relevance and Autoplay.</small> </header>
		<div class="team-wrapper">
			<div class="team" *ngFor="let t of core.teams" (click)="cycleStars(t.abbreviation)">
				<header>
					<i class="material-icons" *ngFor="let index of settings.favourite_teams[t.abbreviation] | range">star</i>
				</header>
				<img [src]="t.logo" alt="">
				<span>{{ t.abbreviation }}</span>
			</div>
		</div>

	</section>


	<section>
		<header>What do you consider to be spoiler:</header>
		<button (click)="settings.toggle('show_live_scores')" [class.active]="!settings.show_live_scores">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Live Game's Scores</span>
		</button>
		<button (click)="settings.toggle('show_final_scores')" [class.active]="!settings.show_final_scores">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Final Game's Scores</span>
		</button>

		<header>What to do with spoilers:</header>
		<button (click)="settings.set('delete_spoilers', true)" [class.active]="settings.delete_spoilers">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Take no risks! <small>(No placeholders)</small></span>
		</button>
		<button (click)="settings.set('delete_spoilers', false)" [class.active]="!settings.delete_spoilers">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Show spoilers under a placeholder. <small>(Hover to show)</small></span>
		</button>
	</section>

	<section>
		<header>Auto Play:</header>
		<button (click)="settings.toggle('autoplay_enabled')" [class.active]="settings.autoplay_enabled">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">{{ settings.autoplay_enabled ? 'Enabled': 'Disabled' }}</span>
		</button>

		@if( !navigator['getAutoplayPolicy'] ){
			<header>Auto Play Audio Policy:</header>
			<button (click)="settings.set('autoplay_muted', true)" [class.active]="settings.autoplay_muted">
				<span class="toggle-button"><i class="material-icons">settings</i></span>
				<span class="text">Start with video muted</span>
			</button>
			<button (click)="settings.set('autoplay_muted', false)" [class.active]="!settings.autoplay_muted">
				<span class="toggle-button"><i class="material-icons">settings</i></span>
				<span class="text">
					Start with audio playing.
					<small>Your browser could block this type of playback without your explicit permission.</small>
				</span>
			</button>
		}

		<header>
			Default Player:
		</header>
		<button (click)="settings.set('player_type', 'clappr')" [class.active]="settings.player_type=='clappr'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Clappr Player</span>
		</button>
		<p class="option-info">
			The Old player we've been using since 2017, Looks homey by now!<br/>
			<span> - Had more time to settle in our system, has less bugs right now, but some of them are unfixable.</span><br/>
			<span> - Worst chromecast support for premium.</span><br/>
		</p>
		<button (click)="settings.set('player_type', 'shaka')" [class.active]="settings.player_type=='shaka'">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Shaka Player</span>
		</button>
		<p class="option-info">
			The Newer player, visually similar to YouTube's player<br/>
			<span> - Modern and has more functionalities.</span><br/>
			<span> - Better chromecast support for premium.</span><br/>
			<span> - Currently Buggy and Experimental.</span>
		</p>
	</section>

	<!--section *ngIf="core.is_debug">
		<header>Alpha Featues / Debug:</header>
		<button (click)="settings.toggle('remove_stream_time_limits')" [class.active]="settings.remove_stream_time_limits">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Remove stream time limits</span>
		</button>
	</section>

	<section *ngIf="navigator['share']">
		<header>Device Specific Preferences:</header>
		<button (click)="settings.toggle('show_sharing')" [class.active]="settings.show_sharing">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Show "Share" Option when media is paused.</span>
		</button>
	</section-->

	<!--section>
		<header>Turbo Intensity: <small class="premium">Premium Only</small></header>
		<button (click)="settings.set('turbo_edge', 2)" [class.active]="settings.turbo_edge==2">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Unrealistic (Average 2s Delay)</span>
		</button>
		<button (click)="settings.set('turbo_edge', 8)" [class.active]="settings.turbo_edge==8">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Extreme (Average 8s Delay)</span>
		</button>
		<button (click)="settings.set('turbo_edge', 13)" [class.active]="settings.turbo_edge==13">
			<span class="toggle-button"><i class="material-icons">settings</i></span>
			<span class="text">Normal (Average 13s Delay)</span>
		</button>
		<p>
			The turbo feature, is in nature unstable, and how much you can push it, depends on your internet connection (ping and speed), your device, and even the stream itself.
			The more you push it, the more likeley it is to <b>start buffering and set the stream back</b> to a normal delay level of around 30s,
			so experiment with it and find the best for your case.<br/>
			Don't forget to disable and re-enable the turbo button after changing the setting.
		</p>
	</section-->


</div>
